import { context } from '@ad-engine/core';

export function isJwpApplicable(): boolean {
	const jwpConfig = context.get('services.jwp.config');
	return !!jwpConfig && Object.keys(jwpConfig).length > 0;
}

export function isDrawerPlayerApplicable(): boolean {
	const jwpConfig = context.get('services.jwpDrawerPlayer');
	return !!jwpConfig && Object.keys(jwpConfig).length > 0;
}
